import React, { useState } from 'react';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { ContentEditable as LexicalContentEditable } from '@lexical/react/LexicalContentEditable';
import { RichTextPlugin as LexicalRichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { HashtagPlugin as LexicalHashtagPlugin } from '@lexical/react/LexicalHashtagPlugin';
import { ListPlugin as LexicalListPlugin } from '@lexical/react/LexicalListPlugin';
import { HistoryPlugin as LexicalHistoryPlugin } from '@lexical/react/LexicalHistoryPlugin';
import LexicalErrorBoundary from '@lexical/react/LexicalErrorBoundary';
import { TablePlugin as LexicalTablePlugin } from '@lexical/react/LexicalTablePlugin';

import AutoLinkPlugin from './plugins/AutoLinkPlugin';
import ToolbarPlugin from './plugins/IVAToolbarPlugin';
import CodeHighlightPlugin from './plugins/CodeHighlightPlugin';
import TreeViewPlugin from './plugins/TreeViewPlugin';
import OnchangePlugin, { Data } from './plugins/OnchangePlugin';
import UploadPlugin from './plugins/UploadPlugin';
import TableActionMenuPlugin from './plugins/IVATablePlugin/TableActionPlugin';

import config from './config';

export type Props = {
  placeholder?: string;
  showDebug?: boolean;
  size?: 'large' | 'small';
  onChange?: (html: string, data: Data) => void;
  html?: string | null;
  onSend?: (html: string) => void | Promise<any>;
  disable?: boolean;
  shouldFocus?: boolean;
};

const Editor: React.FC<Props> = (props) => {
  const {
    placeholder,
    showDebug = false,
    size = 'small',
    onChange,
    html,
    disable = false,
    shouldFocus,
  } = props;

  const [floatingAnchorElem, setFloatingAnchorElem] = useState<
    HTMLDivElement | null | undefined
  >(undefined);

  const onRef = (_floatingAnchorElem: HTMLDivElement) => {
    if (_floatingAnchorElem !== null) {
      setFloatingAnchorElem(_floatingAnchorElem);
    }
  };

  return (
    <LexicalComposer initialConfig={config}>
      <div className="iva-editor-wrapper">
        <ToolbarPlugin />
        <LexicalRichTextPlugin
          ErrorBoundary={LexicalErrorBoundary}
          contentEditable={
            <div ref={onRef}>
              <LexicalContentEditable
                spellCheck
                className={`iva-editor ${size}`}
              />
            </div>
          }
          placeholder={
            <div className="iva-editor-placeholder">{placeholder}</div>
          }
        />
        <CodeHighlightPlugin />
        <OnchangePlugin
          shoulFocus={shouldFocus}
          disable={disable}
          onChange={onChange}
          html={html}
        />
        <AutoLinkPlugin />
        <UploadPlugin />
        <TableActionMenuPlugin anchorElem={floatingAnchorElem!} />

        <LexicalListPlugin />
        <LexicalHashtagPlugin />
        <LexicalHistoryPlugin />
        <LexicalTablePlugin />
        {showDebug && <TreeViewPlugin />}
      </div>
    </LexicalComposer>
  );
};

export default Editor;
